import api from "@/api";

const state = {
  list: { data: [], paging: {} },
  active: {},
  openPO: { data: [], paging: {} }
};
const getters = {
  list: state => {
    return state.list;
  },
  active: state => {
    return state.active;
  },
  openPO: state => {
    return state.openPO;
  }
};
const actions = {
  async getList({ commit }, params) {
    const result = await api.get(`/api/v1/purchase/po_list/`, params);
    if (result && result.status == 200) {
      commit("setList", result.data);
      return result.data;
    }
    return null;
  },
  async getOpenPO({ commit }, params) {
    const result = await api.get(`/api/v1/purchase/po_list/`, params);
    if (result && result.status == 200) {
      commit("setOpenPO", result.data);
      return result.data;
    }
    return null;
  }
};
const mutations = {
  setList: (state, payload) => {
    state.list = payload;
  },
  setActivePO: (state, payload) => {
    state.active = payload;
  },
  setOpenPO: (state, payload) => {
    state.openPO = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
